import { createGlobalStyle } from 'styled-components/macro';
import type { DefaultTheme } from 'styled-components/macro';

function fontWeightNormal(props: { theme: DefaultTheme }): string {
  return props.theme.fontWeight.normal.toString();
}

function fontFamilyPrimary(props: { theme: DefaultTheme }): string {
  return props.theme.fontFamily.primary;
}

function colorPrimaryVariant3(props: { theme: DefaultTheme }): string {
  return props.theme.colors.primary.variant3;
}

function radiusXs(props: { theme: DefaultTheme }): string {
  return props.theme.radius.xs;
}

function colorTransparent(props: { theme: DefaultTheme }): string {
  return props.theme.colors.transparent;
}

function radiusSm(props: { theme: DefaultTheme }): string {
  return props.theme.radius.sm;
}

function colorPrimaryVariant7(props: { theme: DefaultTheme }): string {
  return props.theme.colors.primary.variant7;
}

const GlobalStyle = createGlobalStyle`
  * {
    padding: 0;
    margin: 0;
    border: 0;
    outline: 0;
    font-weight: ${fontWeightNormal};
  }

  html {
    box-sizing: border-box;
    font-size: 100%;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    font-family: ${fontFamilyPrimary};
    background-color: ${colorPrimaryVariant3};
    overflow-x: hidden;

    &[class^="scroll-lock"] {
      overflow: hidden;
    }
  }

  ol, ul {
	  list-style: none;
	}

  a {
    color: inherit;
    text-decoration: none;
  }

  button, input[type="submit"], input[type="reset"] {
    font-family: inherit;
    font-size: inherit;
    background: none;
  }

  ::-webkit-scrollbar-track {
    border-radius: ${radiusXs};
    background-color: ${colorTransparent};
    overflow-x: auto;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: ${colorTransparent};
    overflow-x: auto;

    &:hover {
      width: 12px;
      height: 12px;
    }
  }

  ::-webkit-scrollbar-thumb {
    border-radius:${radiusSm};
    background-color: ${colorPrimaryVariant7};
    overflow-x: auto;
  }

  /* Allow clicking on elements on touch devices during the onboarding tour */
  @media (hover: none) {
    .react-joyride__overlay,
    .react-joyride__spotlight {
      pointer-events: none !important;
    }
  }

#atlwdg-trigger {
  margin: 8px;
  background: #3459B8;
  color: white !important;
  font-size: 10px;
  font-family: 'Roboto',  monospace;
  font-weight: 500;
  line-height: 1;
  border: none;
  border-radius: 4px;
  box-shadow: none;
}

`;

export default GlobalStyle;
